import { defineMessages } from 'react-intl';

export const subscriptionItemsMessages = defineMessages({
    subscriptionItems: {
        id: 'subscription-items',
        defaultMessage: 'Items',
    },
    items: {
        id: 'items',
        defaultMessage: 'Items',
    },
    item: {
        id: 'item',
        defaultMessage: 'Item',
    },
    isActive: {
        id: 'is-active',
        defaultMessage: 'Is active',
    },
    createSubscriptionItemSuccess: {
        id: 'create-subscription-item-success',
        defaultMessage: 'Subscription item created',
    },
    createSubscriptionItemSuccessDescription: {
        id: 'create-subscription-item-success-description',
        defaultMessage: 'The subscription item has been successfully created.',
    },
    addSubscriptionItemSubtitle: {
        id: 'add-subscription-item-subtitle',
        defaultMessage: 'Create a new subscription item',
    },
    deleteSubscriptionItem: {
        id: 'delete-subscription-item',
        defaultMessage: 'Delete subscription item',
    },
    deleteSubscriptionItemSuccess: {
        id: 'delete-subscription-item-success',
        defaultMessage: 'Subscription item deleted',
    },
    deleteSubscriptionItemSuccessDescription: {
        id: 'delete-subscription-item-success-description',
        defaultMessage: 'The subscription item has been successfully deleted.',
    },
    confirmDeleteSubscriptionItem: {
        id: 'confirm-delete-subscription-item',
        defaultMessage: 'Are you sure you want to delete this subscription item? This action cannot be undone.',
    },
    deleteSubscriptionItemSubtitle: {
        id: 'delete-subscription-item-subtitle',
        defaultMessage: 'Permanently delete subscription item',
    },
    subscriptionItemDashboard: {
        id: 'subscription-item-dashboard',
        defaultMessage: 'Subscription item dashboard',
    },
    backToSubscriptionDashboard: {
        id: 'back-to-subscription-dashboard',
        defaultMessage: 'Back to subscription dashboard',
    },
    editSubscriptionItemSubtitle: {
        id: 'edit-subscription-item-subtitle',
        defaultMessage: 'Edit subscription item',
    },
    updateSubscriptionItemSuccess: {
        id: 'update-subscription-item-success',
        defaultMessage: 'Subscription item updated',
    },
    updateSubscriptionItemSuccessDescription: {
        id: 'update-subscription-item-success-description',
        defaultMessage: 'The subscription item has been successfully updated.',
    },
});
